import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class StripechargeService {
  static async list(filter, limit, offset, orderBy) {
    const response = await graphqlClient.query({
      query: gql`
        query STRIPECHARGE_LIST(
          $filter: StripeChargeFilterInput,
          $limit: Int,
          $offset: Int,
          $orderBy: StripeChargeOrderByEnum
        ) {
          stripeChargeList(
            filter: $filter
            limit: $limit
            offset: $offset
            orderBy: $orderBy
          ) {
            count
            rows {
              id
              type
              status
              connectedAccount {
                id
              }
              paymentMethod {
                id
                card {
                  brand
                  last4
                }
              }
              user {
                id
                firstName
                fullName
              }
              stripeChargeId
              stripeFee
              applicationFee
              amount
              currency
              createdAt
              updatedAt
            }
          }
        }
      `,

      variables: {
        filter,
        limit,
        offset,
        orderBy,
      },
    });

    return response.data.stripeChargeList;
  }
}